import { render, staticRenderFns } from "./AgregateClient.vue?vue&type=template&id=9ddad6ae&scoped=true&"
import script from "./AgregateClient.vue?vue&type=script&lang=js&"
export * from "./AgregateClient.vue?vue&type=script&lang=js&"
import style0 from "./AgregateClient.vue?vue&type=style&index=0&id=9ddad6ae&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddad6ae",
  null
  
)

export default component.exports